import React from "react";
import { DetailShell } from "@/components/nds/windows/finance/parts";
import PenaltiesTab from "@/components/nds/windows/finance/PenaltiesTab";
import PenaltyHistoryTab from "@/components/nds/windows/finance/PenaltyHistoryTab";

const TABS = [
  { id: "penalties", label: "Penalties", Tab: PenaltiesTab, tone: "people", desc: "Open and settled penalties for this resident" },
  { id: "history", label: "History", Tab: PenaltyHistoryTab, tone: "system", desc: "Every change made to their penalties" },
];

export default function FinPenaltiesDetail({ resident, onBack }) {
  return <DetailShell prefix="fin-penalties" tabs={TABS} resident={resident} onBack={onBack} />;
}
